import CircleLoader from "./CircleLoader";

export default CircleLoader;
export { CircleLoader };
